import { render, staticRenderFns } from "./ShoppingCard.vue?vue&type=template&id=6568a001&"
import script from "./ShoppingCard.vue?vue&type=script&lang=js&"
export * from "./ShoppingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports